import React, {
  forwardRef, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogActions, DialogContent,
  DialogTitle,
  IconButton,
  Input,
  InputAdornment,
  Button,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTextWidth, faTimes } from '@fortawesome/free-solid-svg-icons';
// eslint-disable-next-line import/no-cycle
import FormatEditor from './editor';

const FormatInput = forwardRef(({
  value, onChange, disabled, readOnly, onReset,
  className, allowedFonts,
}, ref) => {
  const [show, setShow] = useState(false);
  const displayValue = useMemo(
    () => (value ? 'Задано' : 'Не задано'),
    [value],
  );

  // eslint-disable-next-line import/no-cycle
  return (
    <>
      <Input
        ref={ref}
        value={displayValue}
        disabled={disabled}
        readOnly
        className={className}
        endAdornment={(
          <InputAdornment position="end">
            <IconButton onClick={() => setShow((s) => !s)} disabled={readOnly}>
              <FontAwesomeIcon icon={faTextWidth} size="xs" />
            </IconButton>
          </InputAdornment>
      )}
      />
      <Dialog open={show} onClose={() => setShow(false)} maxWidth="xl" fullWidth>
        <DialogTitle>Формат</DialogTitle>
        <DialogContent>
          <FormatEditor
            onChange={onChange}
            value={value}
            allowedFonts={allowedFonts}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              onReset();
              setShow(false);
            }}
            startIcon={(
              <FontAwesomeIcon icon={faTimes} />
            )}
          >
            Reset
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

FormatInput.propTypes = {
  value: PropTypes.shape({
    font: PropTypes.shape({
      name: PropTypes.string,
      size: PropTypes.number,
      bold: PropTypes.bool,
      italic: PropTypes.bool,
      strike: PropTypes.bool,
      underline: PropTypes.bool,
      color: PropTypes.string,
    }),
    background: PropTypes.shape({
      fgColor: PropTypes.string,
    }),
    alignment: PropTypes.shape({
      horizontal: PropTypes.oneOf(['left', 'right', 'center']),
      vertical: PropTypes.oneOf(['top', 'bottom', 'middle']),
    }),
  }),
  onChange: PropTypes.func.isRequired,
  allowedFonts: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  onReset: PropTypes.func.isRequired,
};

FormatInput.defaultProps = {
  value: {},
  allowedFonts: [],
  disabled: false,
  readOnly: false,
  className: null,
};

export default FormatInput;
